import { useTranslation } from 'react-i18next';
import { useEcosystemLinks, type ResolvedLink } from '../lib/cms';

function label(link: ResolvedLink, field: 'title' | 'description', locale: string, fallback: string): string {
  const map = link[field];
  return map[locale] || map.en || fallback;
}

export function EcosystemSection() {
  const { t, i18n } = useTranslation();
  const links = useEcosystemLinks();
  const locale = i18n.language?.split('-')[0] ?? 'en';

  return (
    <section id="ecosystem" className="ecosystem" aria-labelledby="ecosystem-title">
      <div className="container">
        <p className="section-eyebrow" data-i18n="ecosystem.eyebrow">{t('ecosystem.eyebrow')}</p>
        <h2 className="section-title" id="ecosystem-title" data-i18n="ecosystem.title">{t('ecosystem.title')}</h2>
        <p className="section-subtitle" data-i18n="ecosystem.subtitle">{t('ecosystem.subtitle')}</p>

        <div className="ecosystem-grid">
          {links.map((link) => {
            const fallbackTitle = t(`ecosystem.items.${link.slug}.title`, { defaultValue: link.slug });
            const fallbackDesc = t(`ecosystem.items.${link.slug}.description`, { defaultValue: '' });
            const title = label(link, 'title', locale, fallbackTitle);
            const desc = label(link, 'description', locale, fallbackDesc);
            const host = link.url.replace(/^https?:\/\//, '').replace(/\/$/, '');
            return (
              <a
                key={link.slug}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ecosystem-card"
                aria-label={`${title} — ${host}`}
              >
                <span className="ecosystem-badge" aria-hidden="true" style={{ background: link.accent }}>
                  {link.monogram}
                </span>
                <span className="ecosystem-body">
                  <span className="ecosystem-card-title">{title}</span>
                  {desc && <span className="ecosystem-card-desc">{desc}</span>}
                  <span className="ecosystem-host">{host}</span>
                </span>
                <span className="ecosystem-visit" aria-hidden="true">
                  {t('ecosystem.visit')} <span className="ecosystem-arrow">→</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
